/**
 * Approval feature types
 * Re-exports from central types plus feature-specific interfaces
 */

export type {
  ApprovalItem,
  ApprovalFilters,
  ApprovalQueueResponse,
  ApprovalStats,
  ApprovalHistoryWithUsers,
  ApprovalAction,
  ApprovalAttribution,
  FranchiseRegion,
  ReviewStatus,
  PhotoReviewStatus
} from '@/types/gallery';

export type { GalleryAllImage } from '@/lib/supabase';

/**
 * Query key factory for approval-related queries
 * Centralized for consistent cache invalidation
 */
export const approvalKeys = {
  all: ['approval'] as const,
  queue: () => [...approvalKeys.all, 'queue'] as const,
  counts: () => [...approvalKeys.all, 'counts'] as const,
  stats: () => [...approvalKeys.all, 'stats'] as const,
  history: (filters?: ApprovalHistoryFilters) =>
    [...approvalKeys.all, 'history', filters] as const,
  attribution: (entityType: string, entityId: number) =>
    [...approvalKeys.all, 'attribution', entityType, entityId] as const,
};

export interface ApprovalCounts {
  totalPending: number;
  pendingGalleries: number;
  pendingImages: number;
  pendingReviews: number;
}

export interface ApprovalHistoryFilters {
  entity_type?: 'gallery' | 'image';
  entity_id?: number;
  user_id?: string;
  action?: string;
  date_from?: string;
  date_to?: string;
  limit?: number;
}
